export const GLOBAL_CART_FEATURE_NAME = 'cartGlobal';
